module.exports = __webpack_public_path__ + "assets/img/zhanwei.c9d52ff6.png";